module.exports = __webpack_public_path__ + "media/超市.1ca7b3f6.wav";